export const drawingCreatorsAsyncModule = {
  importFn: () => import(/* webpackChunkName: "drawing-creators" */ './module-entry'),
  cacheKey: 'drawing-creators',
}
